<div class="modal-header">
  <div class="modal-title flex-grow-1 {{ robotClassModalTitle }}">
    {{ modalTitleText | translate }}
  </div>
  <div class="close-btn-container">
    @if (!removeCloseButton) {
      <button type="button" class="btn btn-icon {{ robotClassClose }}" aria-label="Close" (click)="bsModalRef.hide()">
        <i class="fa-regular fa-xmark fa-gray fa-normal"></i>
      </button>
    }
  </div>
</div>
<div class="modal-body">
  @if (modalBody) {
    <ng-container #body></ng-container>
  }
  @if (!modalBody && (modalBodyTextKey || '').length > 0) {
    <p class="m-0 {{ robotClassModalBody }}">{{ modalBodyTextKey | translate: modalBodyTextParams }}</p>
  }
  @if (!modalBody && (modalBodyTextKey || '').length === 0 && (modalBodyTextContent || '').length > 0) {
    <p class="m-0 {{ robotClassModalBody }}" [innerHTML]="modalBodyTextContent"></p>
  }
</div>
<div class="modal-footer border-top-0 justify-content-center">
  @if (!reverseButtons) {
    <div class="d-flex overflow-hidden">
      @if ((modalDeclineText || '').length > 0) {
        <button class="btn btn-medium btn-secondary mr-2 {{ robotClassDeclineButton }}" type="button" (click)="close()">
          {{ modalDeclineText | translate }}
        </button>
      }
      @if ((modalAcceptText || '').length > 0) {
        <button class="btn btn-medium btn-primary {{ robotClassAcceptButton }}" type="button" (click)="accept()">
          {{ modalAcceptText | translate }}
        </button>
      }
    </div>
  } @else {
    @if ((modalAcceptText || '').length > 0) {
      <button class="btn btn-medium btn-secondary mr-2 {{ robotClassAcceptButton }}" type="button" (click)="accept()">
        {{ modalAcceptText | translate }}
      </button>
    }
    @if ((modalDeclineText || '').length > 0) {
      <button class="btn btn-medium btn-primary {{ robotClassDeclineButton }}" type="button" (click)="close()">
        {{ modalDeclineText | translate }}
      </button>
    }
  }
</div>
